import type { Mode } from 'src/modules/designStudio/providers';
import type { ErrorScope } from 'src/shared/constants/ErrorScope';

// Custom tags for Sentry reporting/filtering
export enum ErrorTagName {
  SCOPE = 'scope',
  DESIGN_STUDIO_MODE = 'design_studio_mode',
  HOVER_APP_VERSION = 'hover_app_version',
}

export type ErrorTagValue = ErrorScope | Mode | string;
